import { Title, Stack } from "@mantine/core";
import {
  ConocePoliticaDePrevencion,
  HaSidoCapacitado,
  CanalDeDenunciasExiste,
  ConoceProcesoDeInvestigacion,
} from ".";

type Props = {
  form: any;
};

export const SistemaDePrevencion = ({ form }: Props) => {
  return (
    <Stack spacing="lg">
      <Title order={3}>Sistema de prevención</Title>
      <ConocePoliticaDePrevencion form={form} />
      <HaSidoCapacitado form={form} />
      <CanalDeDenunciasExiste form={form} />
      <ConoceProcesoDeInvestigacion form={form} />
    </Stack>
  );
};
